var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4316C24.8366 32.4316 32 25.2682 32 16.4316C32 7.59508 24.8366 0.431641 16 0.431641C7.16344 0.431641 0 7.59508 0 16.4316C0 25.2682 7.16344 32.4316 16 32.4316Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1964 12.2579H19.103C19.1204 12.4879 19.1302 12.7201 19.1302 12.9535C19.1302 14.5012 18.7433 16.0014 18.0689 17.0693C17.8608 17.3987 17.5112 17.8638 17.0432 18.1776V12.2578H14.9562V18.1776C14.4883 17.8638 14.1386 17.3988 13.9305 17.0693C13.256 16.0014 12.8692 14.5012 12.8692 12.9535C12.8692 12.7201 12.8791 12.4879 12.8964 12.2579H10.803C10.7895 12.4868 10.7822 12.7187 10.7822 12.9535C10.7822 17.2445 13.074 20.6057 15.9996 20.6057C18.9252 20.6057 21.217 17.2445 21.217 12.9535C21.2171 12.7187 21.2098 12.4868 21.1964 12.2579Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60895 8.08383H8.69589V9.47514H10.7828V8.08383H12.8698V9.47514H14.9567V8.08383H17.0436V9.47514H19.1306V8.08383H21.2175V9.47514H23.3045V8.08383H25.3914V9.47514H30.4125C27.8246 4.1232 22.3436 0.431641 16.0003 0.431641C9.65695 0.431641 4.17589 4.1232 1.58789 9.47514H6.60895V8.08383Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3916 23.3882V24.7795H23.3046V23.3882H21.2177V24.7795H19.1308V23.3882H17.0438V24.7795H14.9569V23.3882H12.87V24.7795H10.783V23.3882H8.69589V24.7795H6.60895V23.3882H1.58789C4.17589 28.7401 9.65689 32.4317 16.0003 32.4317C22.3436 32.4317 27.8246 28.7401 30.4126 23.3882H25.3916Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.431641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIran);
export default __webpack_public_path__ + "static/media/flag_iran.ef3910b90bc3a95705202f77405c9b91.svg";
export { ForwardRef as ReactComponent };